import React, { useEffect, useState } from "react";
import axios from "axios";
import MoreStoryCard from "./MoreStoryCard";

const API_BASE_URL = `${process.env.REACT_APP_API_URL}/news`;

const MoreStories = ({ currentId }) => {
  const [stories, setStories] = useState([]);

  useEffect(() => {
    fetchStories();
  }, [currentId]);

  const fetchStories = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/getAll`);

      const filteredStories = (res.data.data || [])
        .filter((item) => item._id !== currentId)
        .slice(0, 3);

      setStories(filteredStories);
    } catch (err) {
      console.error(err);
    }
  };

  if (!stories.length) return null;

  return (
    <section className="bg-white py-6 lg:py-8">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">

        {/* Divider */}
        <div className="border-t border-gray-200 pt-10">

          {/* Heading */}
          <h2 className="text-2xl md:text-3xl uppercase tracking-[0.1em] font-semibold text-[#172554] mb-8">
            More Stories
          </h2>

          {/* Cards */}
          <div className="space-y-5">
            {stories.map((story) => (
              <MoreStoryCard
                key={story._id}
                news={story}
              />
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default MoreStories;